<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
    append-to-body
  >
    <dialog-header
      slot="title"
      :title="$t('traffic.selectCar')"
      :icon="'icon-dialog-add'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <div>
        <app-search>
          <div slot="content">
            <el-form
              inline
              :model="listQuery"
              label-suffix="："
              label-width="auto"
            >
              <el-form-item :label="$t('public.licensePlate')">
                <el-input
                  v-model="listQuery.licensePlate"
                  filterable
                  clearable
                  :placeholder="$t('public.licensePlate')"
                />
              </el-form-item>
            </el-form>
          </div>
          <!-- 清空查询按钮 -->
          <app-search-button
            slot="bottom"
            :is-collapse="false"
            @click-filter="handleFilter"
            @click-clear="handleClear"
          />
        </app-search>
        <!-- table -->
        <el-table
          ref="table"
          v-loading="listLoading"
          size="mini"
          :data="list"
          :max-height="tableHeight"
          border
          fit
          highlight-current-row
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @current-change="handleCurrentRowChange"
          @sort-change="sortChange"
        >
          <el-table-column :label="$t('table.id')" align="center" width="60">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="radio">
                <span>{{ scope.$index + 1 }}</span>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in filterTableList"
            :key="index"
            :label="item.value"
            :prop="item.prop"
            :align="item.position"
            :sortable="item.sortable"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'licensePlate'">
                <vue-licenseplate
                  :types="0"
                  :licensepalte="scope.row[item.prop]"
                  :area="scope.row['areaName']"
                />
              </div>
              <span v-else>{{ scope.row[item.prop] || "/" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div
          :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']"
        >
          <el-pagination
            :current-page="listQuery.pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="closeDialog"
        >{{ $t("public.cancel") }}</el-button
      >
      <el-button v-waves type="primary" @click="handleSelected">
        {{ $t("public.define") }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
// request
import { carListUrl, STATUSNUMBER } from '@/api/traffic'

export default {
  name: 'selectCarDialog',
  components: {},
  mixins: [pagingMixin, otherHeight],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  data() {
    return {
      listQuery: {
        carTerminalStatus: STATUSNUMBER
      },
      showfilter: false,
      tableList: [
        { value: this.$t('public.licensePlate'), prop: 'licensePlate', position: 'center', checked: true, sortable: true },
        { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center', checked: true, sortable: true },
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      currentRow: null,
      radio: ''
    }
  },
  methods: {
    listLoad() {
      this.listLoading = true
      this.$http.post(carListUrl, this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
          let orderSort = 'licensePlate,barCode'
          this.setOrderField(orderSort, this.tableList)
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 获取选中行的索引
    tableRowClassName({ row, rowIndex }) {
      row.$rowIndex = rowIndex
    },
    // 检测是否未选择
    checkCurrentRowEmpty() {
      return !this.currentRow
    },
    // 所选行改变
    handleCurrentRowChange(val) {
      this.currentRow = val
      this.radio = val.$rowIndex
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 已选处理
    handleSelected() {
      this.$emit('select-complete', this.currentRow.carId, this.currentRow.licensePlate)
      this.closeDialog()
    }
  }
}
</script>
